import React from "react";
import { returnToPageboxLogin } from "./pageboxNavigation";

export function PageboxAccountNotice({ fontSize, password = false, login = false, qrEntry = false }: {
    fontSize: React.CSSProperties["fontSize"]; password?: boolean; login?: boolean; qrEntry?: boolean;
}) {
    return <section aria-label="페이지박스 공통 계정 안내" style={{
        border: "1px solid #888", borderRadius: 8, padding: "1em",
        marginBottom: "1em", fontSize, lineHeight: 1.6, color: "#111", background: "#fff",
    }}>
        <strong>독서노트 계정으로도 이용할 수 있어요.</strong>
        <div>{password
            ? "비밀번호를 변경하면 페이지박스와 독서노트 모두에 적용됩니다."
            : "페이지박스와 독서노트는 같은 계정을 사용합니다. 이미 가입했다면 새 계정을 만들 필요가 없어요."}</div>
        {qrEntry && login && <p>휴대폰에서 회원가입을 완료한 뒤, 페이지박스 기기에서 로그인해주세요.</p>}
        {login && <button type="button" onClick={() => void returnToPageboxLogin(qrEntry)}
            style={{ fontSize: "inherit", padding: "0.5em 1em", marginTop: "0.7em", border: "1px solid #111", borderRadius: 6, background: "#fff", color: "#111" }}>
            {qrEntry ? "로그인 안내" : "로그인으로 돌아가기"}
        </button>}
    </section>;
}
